module.exports = __webpack_public_path__ + "img/img1.84472bc6.png";